'use client';

import React from 'react';
import Image from 'next/image';

import { STORE_LINKS } from '@/constants/downloadApp';

import classes from '../../index.module.css';
import { Store, StoreButtonsProps } from './models';

import { Apple } from 'iconsax-react';

const STORES: Store[] = [
    {
        id: 'myket',
        href: STORE_LINKS.myket,
        label: 'دانلود از مایکت',
        sub: 'Myket',
        logo: { src: '/images/app-stores/myket-logo.png', alt: 'لوگوی مایکت', width: 26, height: 26 }
    },
    {
        id: 'bazaar',
        href: STORE_LINKS.bazaar,
        label: 'دانلود از کافه‌بازار',
        sub: 'Cafe Bazaar',
        logo: { src: '/images/app-stores/cafebazar-logo.png', alt: 'لوگوی کافه‌بازار', width: 26, height: 26 }
    }
];

const StoreButtons = ({ theme = 'dark', className = '' }: StoreButtonsProps) => {
    const isDark = theme === 'dark';

    const buttonClassName = [
        classes.storeBtn,
        'flex min-h-[56px] cursor-pointer items-center gap-3 rounded-lg px-5 py-2.5 ',
        isDark
            ? `${classes.glassDark} text-white hover:bg-white/15`
            : 'border border-N300 bg-white text-blackHighEmphasis shadow-elevation1 hover:border-primary'
    ].join(' ');

    return (
        <div className={`flex flex-wrap items-stretch justify-center gap-3 ${className}`} role='group' aria-label='لینک‌های دانلود اپلیکیشن'>
            {STORES.map((store) => (
                <a key={store.id} href={store.href} target='_blank' rel='noopener noreferrer' aria-label={store.label} className={buttonClassName}>
                    <span className='flex h-8 w-8 shrink-0 items-center justify-center'>
                        {store.logo ? (
                            <Image
                                src={store.logo.src}
                                alt={store.logo.alt}
                                width={store.logo.width}
                                height={store.logo.height}
                                className='h-7 w-7 object-contain'
                            />
                        ) : (
                            store.icon
                        )}
                    </span>
                    <span className='flex flex-col items-start leading-tight'>
                        <span className={`text-[11px] ${isDark ? 'text-whiteMediumEmphasis' : 'text-blackMediumEmphasis'}`}>{store.sub}</span>
                        <span className='text-sm font-bold'>{store.label}</span>
                    </span>
                </a>
            ))}

            <a href={STORE_LINKS.pwa} aria-label='نسخه iOS وب‌اپ' className={buttonClassName}>
                <span className='flex h-8 w-8 shrink-0 items-center justify-center'>
                    <Apple size={26} variant='Bold' color='currentColor' aria-hidden />
                </span>
                <span className='flex flex-col items-start leading-tight'>
                    <span className={`text-[11px] ${isDark ? 'text-whiteMediumEmphasis' : 'text-blackMediumEmphasis'}`}>نسخه iOS (PWA)</span>
                    <span className='text-sm font-bold'>افزودن به صفحه اصلی</span>
                </span>
            </a>
        </div>
    );
};

export default StoreButtons;
